import { Pipe, PipeTransform } from '@angular/core';
import { ProductNames } from '../../models/SubscriptionsModels';
import { computeButtonText, BuildMembershipsCtx } from '../plans';

@Pipe({ name: 'planCardButtonText', pure: true })
export class PlanCardButtonTextPipe implements PipeTransform {
    transform(planName: ProductNames, ctx: BuildMembershipsCtx, isCurrentPlan: boolean): string {
        return computeButtonText(planName, ctx, isCurrentPlan);
    }
}
